<template>
  <div class="wait-item-box">
    <div v-for="(item, index) in list" :key="index" class="wait-item-card" @click="goDetail(item)">
      <!-- 左侧海报 -->
      <div class="movie-poster">
        <img class="poster-img" :src="item.pic" />
        <!-- 想看人数显示在左上角 -->
        <div class="poster-like" v-if="item.like">{{ item.like }}人想看</div>
      </div>
      
      <!-- 右侧信息 -->
      <div class="movie-content">
        <div class="movie-name">{{ item.name }}</div>
        <div class="movie-info-row" v-if="item.filmTypes">
          <span class="info-label">类型:</span>
          <span class="info-value">{{ item.filmTypes }}</span>
        </div>
        <div class="movie-info-row" v-if="item.director">
          <span class="info-label">导演:</span>
          <span class="info-value">{{ item.director }}</span>
        </div>
        <div class="movie-info-row" v-if="item.cast">
          <span class="info-label">主演:</span>
          <span class="info-value text-ellipsis">{{ item.cast }}</span>
        </div>
        <!-- 底部区域：上映日期 + 预售按钮 -->
        <div class="movie-bottom">
          <div class="release-info" v-if="item.publishDate">
            <span class="release-date">{{ formatDate(item.publishDate) }} 上映</span>
          </div>
          <!-- 预售按钮 - 如果在热映列表中 -->
          <div v-if="isInHotList(item)" class="presale-btn" @click.stop="goCinema(item)">预售</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WaitItem",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    hotFilmIds: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isInHotList(item) {
      return this.hotFilmIds.includes(item.filmId);
    },
    
    goDetail(val) {
      const canBuy = this.isInHotList(val);
      this.$router.push({
        path: "/MovieDetail",
        query: {
          showbutton: canBuy ? 1 : 2,
          item: JSON.stringify(val),
        },
      });
    },
    
    // 预售购票 - 跳转到选择影院页面
    goCinema(val) {
      this.$router.push({
        path: "/Cinema",
        query: {
          filmId: val.filmId,
          movieName: val.name,
        },
      });
    },
    
    formatDate(dateStr) {
      if (!dateStr) return '';
      return this.$moment(dateStr).format('M月D日');
    }
  },
};
</script>

<style lang='scss' scoped>
.wait-item-box {
  background: transparent; 
}

.wait-item-card {
  display: flex;
  background: #fff;
  border-radius: 0.8rem;
  padding: 0.8rem;
  margin-bottom: 0.8rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  
  &:active {
    background: #f9f9f9;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
}

.movie-poster {
  width: 5.8rem;
  height: 8rem;
  min-width: 5.8rem;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.poster-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.poster-like {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(135deg, #ff9800 0%, #ffb74d 100%);
  padding: 0.1rem 0.4rem;
  border-bottom-right-radius: 0.5rem;
  color: #fff;
  font-size: 0.6rem;
  font-weight: 600;
}

.movie-content {
  flex: 1;
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.movie-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.movie-info-row {
  display: flex;
  font-size: 0.75rem;
  color: #666;
  margin-bottom: 0.35rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-label {
  color: #999;
  margin-right: 0.4rem;
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 底部区域 */
.movie-bottom {
  margin-top: auto;
  padding-top: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.release-info {
  flex: 1;
}

.release-date {
  font-size: 0.75rem;
  color: #ff9800;
  font-weight: 500;
}

/* 预售按钮 - 与MovieItem保持一致 */
.presale-btn {
  padding: 0.35rem 1rem;
  background: linear-gradient(135deg, #4a9fff 0%, #65b0ff 100%);
  border-radius: 1rem;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 500;
  box-shadow: 0 4px 10px rgba(74, 159, 255, 0.25);
  
  &:active {
    opacity: 0.9;
  }
}
</style>